import { createStyles } from "@mantine/core";
import { pxToRem } from "theme";

interface ImpactSelectorProps {
  editable: boolean;
}

export const useStyles = createStyles((_, { editable }: ImpactSelectorProps) => ({
  impactSelector: {
    height: "15%",
    width: "15%",
    position: "absolute",
    cursor: editable ? "pointer" : "default",
    WebkitTapHighlightColor: "transparent",
  },
  selectorCheckbox: {
    display: "none",
    accentColor: "transparent",
  },
  carPicture: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  carPictureContainer: {
    padding: pxToRem[20],
    justifyContent: "center",
    minHeight: pxToRem[464],
    height: "500px",
    width: "325px",
    position: "relative",
  },
  /** Technique found here @see {@link https://webaim.org/techniques/css/invisiblecontent/} */
  showOnlyToScreenReaders: {
    clip: "rect(1px, 1px, 1px, 1px)",
    clipPath: "inset(50%)",
    height: "1px",
    width: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
  },
}));
